import React from "react";
import { styled } from "styled-components";
import { Subtitle } from "./shared/Subtitle";
import { Link } from "react-router-dom";

const FooterStyled = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${theme.colors.blue};
  padding: 20px;

  a {
    color: ${theme.colors.white};
  }

  .footer-links {
    margin-bottom: 10px;
  }

  p {
    color: white;
  }

  @media (min-width: 775px) {
    flex-direction: row;

    .footer-links {
      margin-bottom: 0px;
      position: relative;
    }

    .footer-links::before {
      content: "|";
      color: ${theme.colors.white};
      margin: 0 14px 0 0;
      position: relative;
      left: 7px;
    }
  }
`
);

const Footer = () => {
  return (
    <FooterStyled>
      <p>© 2025 BEYOND THE CODE</p>
      <div className="footer-links">
        <Link to="/privacy-policy" target="_blank">
          Política de Privacidad
        </Link>
      </div>
      <div className="footer-links">
        <Link to="/terms-and-conditions" target="_blank">
          Términos de Uso
        </Link>
      </div>
      <div className="footer-links">
        <Link to="/cookies" target="_blank">
          Política de Cookies
        </Link>
      </div>
    </FooterStyled>
  );
};

export default Footer;
